/**
 * №14.1.1-C — the auth surface wrapper.
 *
 * Every pre-auth screen (login/OTP, the OAuth callback, the approval callback,
 * the AuthGuard's waiting state) mounts inside `.appshell` so it inherits the ONE
 * component layer's alias tokens and canonical components; `--auth` swaps the
 * shell's topbar/rail grid for a centred pane. Importing the layer here is what
 * kills the sixth orphan system: there is no second stylesheet to drift.
 */
/*
 * The layer is NOT imported here. `App.tsx` statically imports `AppShellRoot` →
 * `AppShellLayout`, which imports tokens + shell-themes + app-chrome, so the
 * layer is already in the bundle before any auth screen renders. Importing it
 * again from here moves it EARLIER in the module graph, which reorders the CSS
 * cascade against `index.css` and visibly shifted unrelated App Shell surfaces
 * (caught by the snapshot gate, not by eye). Order is load-bearing; leave it.
 */
import type { ReactNode } from "react";

/**
 * №11.5 (D-ADM4) — `shellTheme` opts the auth surface INTO a vertical skin. Absent
 * (the default, and every context-less signup) → no `data-shell-theme` attribute,
 * so the neutral-Kuvio override in shell-themes.css applies (the "green login" fix).
 * Present (a workspace-hinted link) → the vertical accent renders. Only a
 * whitelisted theme is ever passed here (LoginPage), never raw user input.
 */
export function AuthShell({ children, shellTheme }: { children: ReactNode; shellTheme?: string }) {
  return (
    <div className="appshell appshell--auth" data-v3 data-shell-theme={shellTheme || undefined}>
      <div className="authpane">{children}</div>
    </div>
  );
}
